import React, { useState, useEffect } from 'react'
import { Box, Heading, Paragraph as ParagraphG } from 'grommet'
import styled from 'styled-components'
import Group from './group'
import { useSelector } from 'react-redux'
import { device } from '../../theme/device'

const Container = styled(Box)`
  background-color: ${props => props.theme.global.colors.baseBackground};
  border-radius: 2rem;
  /* border: 3px solid ${props => props.theme.global.colors.border};
   */
  box-shadow: 0px 0px 2px 1px ${props => props.theme.global.colors.border};
  flex: 1 0 100%;
  padding: 1.5rem;
  @media (max-width: 1300px) {
    padding: 0.8rem;
  }
`

const GroupsContainer = styled(Box)`
  margin: 0 -1rem;
  & > * {
    margin: 1rem;
  }

  &::-webkit-scrollbar {
    width: 5px !important;
  }
  &::-webkit-scrollbar-track {
    background: transparent !important;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.global.colors.scrollThumb} !important;
    border-radius: 3px;
  }

  /* Handle on hover */
  /* &::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.global.colors.accent} !important;
  } */
`

const Paragraph = styled(ParagraphG)`
  /* color: white; */
  /* font-size: 1.8rem; */
  @media ${device.medium} {
    font-size: 1.8rem;
  }
`
const Result = () => {
  const {
    groups,
    groupNames,
    evenSplit,
    showIcon,
    // boardModal,
    representativeIndexes,
  } = useSelector(state => state.rtg)
  const groupingDuration = useSelector(
    state => state.settings.rtgSpinBehavior.groupingDuration,
  )
  const isToolSpinning = useSelector(state => state.common.isToolSpinning)
  const groupColorsPersist = useSelector(
    state => state.settings.wheelColors.colors,
  )

  const [groupColors, setGroupColors] = useState(['', '', '', ''])

  useEffect(() => {
    setGroupColors(groupColorsPersist)
  }, [groupColorsPersist])

  let groupNum = 0
  return (
    <Container align="stretch">
      {groups.length === 0 ? (
        <Box gap="1rem">
          <Heading level={2} size="2.5rem">
            HOW TO USE
          </Heading>
          <Box>
            <Paragraph>1. Insert participants one by one or by list.</Paragraph>
            <Paragraph>
              2. Select the gender of the participants. (Optional)
            </Paragraph>
            <Paragraph>3. Balance gender distribution. (Optional)</Paragraph>
            <Paragraph>4. Select how many groups to be distributed.</Paragraph>
            <Paragraph>5. Wait for the result.</Paragraph>
            <Paragraph>6. Download result as CSV file (Optional)</Paragraph>
          </Box>
        </Box>
      ) : (
        <Box>
          <Heading level={3}>3. RESULT</Heading>
          <GroupsContainer
            direction="row"
            justify="center"
            width="100%"
            // gap="2rem"
            align="center"
            alignSelf="center"
            wrap={true}
            overflow={{ horizontal: 'hidden', vertical: 'auto' }}
          >
            {groups.map((group, index) => {
              const representativeIndex = representativeIndexes[index]
              const colorIndex = groupNum % groupColors.length
              groupNum = groupNum + 1
              return (
                <Group
                  key={`Team ${groupNum}`}
                  groupName={groupNames[index]}
                  teamNum={groupNum}
                  members={group}
                  groupColor={groupColors[colorIndex]}
                  evenSplit={evenSplit}
                  showIcon={showIcon}
                  isToolSpinning={isToolSpinning}
                  representativeIndex={representativeIndex}
                  groupingDuration={groupingDuration}
                />
              )
            })}
          </GroupsContainer>
        </Box>
      )}
    </Container>
  )
}

export default Result
